import { RegistryFormData } from "@/components/Registry";
import { Validate } from "react-hook-form";
import { DateTime } from "luxon";

export function boolString(value: boolean | null | undefined): "yes" | "no" | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  return value ? "yes" : "no";
}

type Boolish = "yes" | "no" | "true" | "false" | true | false | string | undefined | null;
const trueValues: Boolish[] = ["yes", "true", true];
const falseValues: Boolish[] = ["no", "false", false];
const prepBoolish = (value: Boolish): Boolish => {
  if (typeof value === "string") {
    return value.toLowerCase() as Boolish;
  }
  return value;
};

export type Option = {
  label: string;
  value: string;
};

export function boolify(value: Boolish): boolean | undefined {
  const prepped = prepBoolish(value);
  if (trueValues.includes(prepped)) {
    return true;
  } else if (falseValues.includes(prepped)) {
    return false;
  } else {
    return undefined;
  }
}

export function booleanValidator(
  errorMessage: string,
  enabled: boolean = true,
): Validate<boolean | null, RegistryFormData> {
  return (value: boolean | null | undefined) => {
    if (enabled && (value === null || value === undefined)) {
      return errorMessage;
    }
    return true;
  };
}

export function minAgeValidator(
  errorMessage: string,
  minAge: number = 18,
  enabled: boolean = true,
): Validate<string | null, RegistryFormData> {
  return (value: string | null | undefined) => {
    if (enabled) {
      if (value === null || value === undefined) {
        return errorMessage;
      }
      try {
        const inputDate = DateTime.fromFormat(value, "yyyy-MM-dd");
        const minDate = DateTime.now().minus({ years: minAge }).startOf("day");
        if (inputDate.toMillis() > minDate.toMillis()) {
          return errorMessage;
        }
        return true;
      } catch (e) {
        console.error("Error parsing date", e);
        return errorMessage;
      }
    }
    return true;
  };
}
export function compose<T, U, V>(f: (x: T) => U, g: (x: U) => V): (x: T) => V {
  return (x: T) => g(f(x));
}
